import _regeneratorRuntime from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/inherits";
import { RoughGeneratorAsync } from './generator-async';
import { RoughCanvasBase } from './canvas-base';
export var RoughCanvasAsync =
/*#__PURE__*/
function (_RoughCanvasBase) {
  _inherits(RoughCanvasAsync, _RoughCanvasBase);

  function RoughCanvasAsync(canvas, config) {
    var _this;

    _classCallCheck(this, RoughCanvasAsync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoughCanvasAsync).call(this, canvas));
    _this.genAsync = new RoughGeneratorAsync(config || null, _this.canvas);
    return _this;
  }

  _createClass(RoughCanvasAsync, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.genAsync.defaultOptions;
    }
  }, {
    key: "line",
    value: function () {
      var _line = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(x1, y1, x2, y2, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.genAsync.line(x1, y1, x2, y2, options);

              case 2:
                d = _context.sent;
                this.draw(d);
                return _context.abrupt("return", d);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function line(_x, _x2, _x3, _x4, _x5) {
        return _line.apply(this, arguments);
      }

      return line;
    }()
  }, {
    key: "rectangle",
    value: function () {
      var _rectangle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(x, y, width, height, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.genAsync.rectangle(x, y, width, height, options);

              case 2:
                d = _context2.sent;
                this.draw(d);
                return _context2.abrupt("return", d);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function rectangle(_x6, _x7, _x8, _x9, _x10) {
        return _rectangle.apply(this, arguments);
      }

      return rectangle;
    }()
  }, {
    key: "ellipse",
    value: function () {
      var _ellipse = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(x, y, width, height, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.genAsync.ellipse(x, y, width, height, options);

              case 2:
                d = _context3.sent;
                this.draw(d);
                return _context3.abrupt("return", d);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ellipse(_x11, _x12, _x13, _x14, _x15) {
        return _ellipse.apply(this, arguments);
      }

      return ellipse;
    }()
  }, {
    key: "circle",
    value: function () {
      var _circle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(x, y, diameter, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.genAsync.circle(x, y, diameter, options);

              case 2:
                d = _context4.sent;
                this.draw(d);
                return _context4.abrupt("return", d);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function circle(_x16, _x17, _x18, _x19) {
        return _circle.apply(this, arguments);
      }

      return circle;
    }()
  }, {
    key: "linearPath",
    value: function () {
      var _linearPath = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(points, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.genAsync.linearPath(points, options);

              case 2:
                d = _context5.sent;
                this.draw(d);
                return _context5.abrupt("return", d);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function linearPath(_x20, _x21) {
        return _linearPath.apply(this, arguments);
      }

      return linearPath;
    }()
  }, {
    key: "polygon",
    value: function () {
      var _polygon = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(points, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.genAsync.polygon(points, options);

              case 2:
                d = _context6.sent;
                this.draw(d);
                return _context6.abrupt("return", d);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function polygon(_x22, _x23) {
        return _polygon.apply(this, arguments);
      }

      return polygon;
    }()
  }, {
    key: "arc",
    value: function () {
      var _arc = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(x, y, width, height, start, stop) {
        var closed,
            options,
            d,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                closed = _args7.length > 6 && _args7[6] !== undefined ? _args7[6] : false;
                options = _args7.length > 7 ? _args7[7] : undefined;
                _context7.next = 4;
                return this.genAsync.arc(x, y, width, height, start, stop, closed, options);

              case 4:
                d = _context7.sent;
                this.draw(d);
                return _context7.abrupt("return", d);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function arc(_x24, _x25, _x26, _x27, _x28, _x29) {
        return _arc.apply(this, arguments);
      }

      return arc;
    }()
  }, {
    key: "curve",
    value: function () {
      var _curve = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(points, options) {
        var d;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.genAsync.curve(points, options);

              case 2:
                d = _context8.sent;
                this.draw(d);
                return _context8.abrupt("return", d);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function curve(_x30, _x31) {
        return _curve.apply(this, arguments);
      }

      return curve;
    }()
  }, {
    key: "path",
    value: function () {
      var _path = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(d, options) {
        var drawing;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.genAsync.path(d, options);

              case 2:
                drawing = _context9.sent;
                this.draw(drawing);
                return _context9.abrupt("return", drawing);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function path(_x32, _x33) {
        return _path.apply(this, arguments);
      }

      return path;
    }()
  }, {
    key: "generator",
    get: function get() {
      return this.genAsync;
    }
  }]);

  return RoughCanvasAsync;
}(RoughCanvasBase);